import { mergeStyles, IPersonaProps, BasePicker, IBasePicker, ISuggestionItemProps, ITag, TagItem, TagPicker } from "@fluentui/react";
import React from "react";
import { localize } from "src/l10n";
import { Style } from "src/ui/helpers";
import { SpintrUser } from "..";
import ITokenizedInputItem from "./ITokenizedInputItem";
import { setConfirmPopup } from "src/popups/actions";
import { SpintrTypes } from "src/typings";

interface ITagPlus extends IPersonaProps {
    isNewItem: boolean;
}

export type TokenizedInputChangeHandler = (items: ITokenizedInputItem[]) => void;

export type TokenizedInputAutocompleteCallback = (text: string) => Promise<ITokenizedInputItem[]>;
  
export class NormalPicker extends BasePicker<any, any> {
    public static defaultProps = {};
}

export class SpintrTagPicker extends BasePicker<any, any> {
    public static defaultProps = {
        onRenderItem: (props) => {
            return <TagItem {...props}>{props.item.name}</TagItem>;
        },
    };
}

export interface ITokenizedInputFabricProps {
    autocomplete?: TokenizedInputAutocompleteCallback;
    items: ITokenizedInputItem[];
    onChange: any;
    placeholder?: string;
    hideImage: boolean;
    enableNewItems: boolean;
    itemLimit: number;
    showAllWhenEmpty?: boolean;
    id?: string;
    addEmails?: boolean;
}

export interface ITokenizedInputFabricState {
    text: string;
}

const SuggestedBigItem: (target, itemProps) => JSX.Element = (target: any, itemProps: ISuggestionItemProps<any>) => (
    <div style={{ padding: Style.getSpacing(2) }}>
        <SpintrUser
            imageUrl={target && target.imageUrl}
            name={target.isNewItem ? (target.name + " (" + localize("LaggTillNyRoll") + ")") : target.name}
            subText={target.subText}
            personalName={target.type === SpintrTypes.UberType.User} />
    </div>
);

const suggestedEmailItem: (target, itemProps) => JSX.Element = (target: any, itemProps: ISuggestionItemProps<any>) => (
    <div style={{ padding: Style.getSpacing(2) }}>
        <SpintrUser
            imageUrl={target && target.imageUrl}
            name={target.isNewItem ? (target.name + " (" + localize("LaggTillEpostadresserIUtskickslistan") + ")") : target.name}
            subText={target.subText}
            personalName={target.type === SpintrTypes.UberType.User} />
    </div>
);

const rootClass = mergeStyles({
    //maxWidth: 500,
});

export interface Props extends ITokenizedInputFabricProps {
    disabled?: boolean;
    initialInputText?: string;
    dispatch?: any;
}

class TokenizedInputFabric extends React.Component<Props, ITokenizedInputFabricState> {
    private picker = React.createRef<IBasePicker<ITag>>();

    constructor(props: ITokenizedInputFabricProps) {
        super(props);

        this.state = {
            text: "",
        };
    }
    private _getTextFromItem(props: any): any {
        return props.name;
    }

    private listContainsDocument(tag: ITag, tagList?: ITag[]) {
        if (!tagList || !tagList.length || tagList.length === 0) {
            return false;
        }
        return tagList.filter((compareTag) => compareTag.key === tag.key).length > 0;
    }

    private _onFilterChanged = (text, tagList) => {
        const trimmedText = (text || "").trim();
        if (!this.props.autocomplete || !trimmedText) {
            return [];
        }

        return this.props.autocomplete(trimmedText).then(
            (items) => {
                let newItems = items
                    .map((i) => {
                        return { key: i.key, name: i.name, isNewItem: false, ...i };
                    })
                    .filter((tag) => !this.listContainsDocument(tag, tagList));

                if (!this.props.enableNewItems ||
                    newItems.find((i) => i.key === text) ||
                    newItems.find((i) => i.name.toLowerCase() === text.toLowerCase())) {
                    return newItems;
                } else {
                    return [{ key: text, name: text, isNewItem: true }].concat(newItems);
                }
            },
            (reason: any) => {
                console.log(reason);
            }
        );
    };

    public render(): JSX.Element {
        let items = this.props.items;

        if (this.props.showAllWhenEmpty && (!items || items?.length < 1)) {
            items = [{ key: "alla-0", name: localize("Alla") }];
        } else if (this.props.showAllWhenEmpty && this.props.items?.length > 1) {
            items = items.filter((i) => {
                return i.name !== localize("Alla");
            });
        }

        return (
            <div className={rootClass}>
                {this.props.hideImage ? (
                    <TagPicker
                        id={this.props.id}
                        disabled={this.props.disabled}
                        removeButtonAriaLabel={localize("TaBort")}
                        //@ts-ignore
                        onResolveSuggestions={this._onFilterChanged}
                        onChange={this.props.onChange}
                        getTextFromItem={this._getTextFromItem}
                        //@ts-ignore
                        selectedItems={this.props.items}
                        inputProps={{
                            "aria-label": localize("SokOchLaggTill"),
                            placeholder: this.props.placeholder || localize("SokOchLaggTill"),
                            id: this.props.id
                        }}
                    />
                ) : (
                    <NormalPicker
                        id={this.props.id}
                        disabled={this.props.disabled}
                        removeButtonAriaLabel="Remove"
                        itemLimit={this.props.itemLimit}
                            onRenderItem={(itemProps: any) => {
                                return (
                                    <TagItem {...itemProps} onRemoveItem={() => {
                                        const onChange = () => {
                                            const newItems = itemProps.item.key !== undefined ?
                                                items.filter((i) => i.key !== itemProps.item.key) :
                                                //@ts-ignore
                                                items.filter((i) => i.id !== itemProps.item.id);

                                            this.props.onChange(newItems);
                                        }

                                        if (this.props.dispatch) {
                                            this.props.dispatch(setConfirmPopup({
                                                isOpen: true,
                                                title: localize("TaBort"),
                                                message: localize("VillDuVerkligenTaBortX")
                                                    .replace("{{X}}", itemProps.item.name),
                                                onConfirm: onChange
                                            }))
                                        } else {
                                            onChange();
                                        }
                                    }}>
                                    {
                                        <SpintrUser
                                            name={itemProps.item.name}
                                            size={24}
                                            subText={itemProps.item.subText}
                                            imageUrl={itemProps.item.imageUrl}
                                            personalName={itemProps.item.type === SpintrTypes.UberType.User}
                                        />
                                    }
                                    </TagItem>
                                );
                            }}
                        onRenderSuggestionsItem={this.props.addEmails ? suggestedEmailItem : SuggestedBigItem as any}
                        //@ts-ignore
                        onResolveSuggestions={this._onFilterChanged}
                        onChange={(data) => {
                            this.props.onChange(data.filter((i) => i.key !== "alla-0"));
                        }}
                        getTextFromItem={this._getTextFromItem}
                        selectedItems={items}
                            onItemSelected={(item: ITagPlus): ITagPlus | null => {
                            if (item && item.isNewItem) {
                                //alert("New item added, make any necessary backend calls.");
                            }
                            return item;
                        }}
                        onDismiss={() => {
                            return false; // On click outside, don't select active item
                        }}
                        pickerSuggestionsProps={
                            {
                                //  suggestionsHeaderText: "Suggested Groups",
                                //    noResultsFoundText: "No groups Found",
                            }
                        }
                        inputProps={{
                            placeholder: this.props.placeholder || localize("SokOchLaggTill"),
                            defaultVisibleValue: this.props.initialInputText,
                            "aria-label": "Group Picker",
                            id: this.props.id,
                            onKeyDown: ((e) => {
                                if (e.which === 8) {
                                    //Backspace
                                    e.stopPropagation()
                                }

                            })
                        }}
                    />
                )}
            </div>
        );
    }
}

export default TokenizedInputFabric;
